import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogItemLabel = styled(Typography)(() => ({
  fontSize: '0.938rem',
  marginBottom: 4,
}));
